import React, { useState } from 'react'
import Styles from './header.module.css'
import { AiOutlineLogout } from 'react-icons/ai'
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri'
import { NavLink, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from 'react-redux';
import { clearUserData } from '../slices/loginSlice.js'
import NavItem from '../nav.js'
import jwt_decode from "jwt-decode";
import { isEmpty } from 'lodash';
import { ACCESS_LEVEL } from '../constant/constant.js'

function Header() {
    const login = useSelector(state => state.loginSlice)
    const accessCookies = useSelector(state => state.loginSlice)
    const user = !isEmpty(accessCookies.token) ? jwt_decode(accessCookies.token) : { accessLevel: 0 }

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [mobileNavOpen, setMobileNavOpen] = useState(false)

    const handleLogout = () => {
        const confirmLogout = window.confirm("Are you sure you want to log out?");
        if (confirmLogout) {
            dispatch(clearUserData());
            navigate('/login');
        }
    }

    const checkNav = (data) => {
        try {
            if (user.accessLevel >= ACCESS_LEVEL.ADMIN) return true;
            // No blanket "access_level <= yours" pass below admin -- Access
            // Module (permissions) is the sole, exhaustive source of truth for
            // what a sub-admin/cashier account can see. Give a plain cashier
            // account their base tasks by putting those modules in their
            // Access Module list, same as any other module.
            const userAccess = user.accessModule;
            return Array.isArray(userAccess) && userAccess.some(item =>
                item?.module &&
                item.module.split(' ')
                    .map(s => s.charAt(0).toUpperCase() + s.slice(1))
                    .join(' ') === data.title
            );
        } catch {
            return false;
        }
    }

    const visibleNavItems = NavItem.filter(data => checkNav(data))

    return (
        <div className={Styles.header}>
            <div className={Styles.topRow}>
                <div className={Styles.logo}>
                    <h2>
                        <span>R</span><span>e</span><span>a</span><span>l</span>
                        <span className={Styles.space}> </span>
                        <span>C</span><span>l</span><span>u</span><span>b</span>
                    </h2>
                </div>
                <div className={Styles.userInfo}>
                    <span className={Styles.email}>{login?.email}</span>
                    <AiOutlineLogout className={Styles.logoutIcon} onClick={handleLogout} title="Logout" />
                    <button
                        className={Styles.hamburger}
                        onClick={() => setMobileNavOpen(v => !v)}
                        aria-label="Toggle navigation"
                    >
                        {mobileNavOpen ? <RiCloseLine /> : <RiMenu3Line />}
                    </button>
                </div>
            </div>

            {/* Desktop nav */}
            <nav className={Styles.navRow}>
                {visibleNavItems.map((data, index) => (
                    <NavLink
                        key={index}
                        to={data.path}
                        className={({ isActive }) =>
                            isActive ? `${Styles.navLink} ${Styles.active}` : Styles.navLink
                        }
                    >
                        {data.icon}
                        <span>{data.title}</span>
                    </NavLink>
                ))}
            </nav>

            {/* Mobile nav dropdown */}
            {mobileNavOpen && (
                <nav className={Styles.mobileNav}>
                    {visibleNavItems.map((data, index) => (
                        <NavLink
                            key={index}
                            to={data.path}
                            onClick={() => setMobileNavOpen(false)}
                            className={({ isActive }) =>
                                isActive ? `${Styles.mobileNavLink} ${Styles.mobileActive}` : Styles.mobileNavLink
                            }
                        >
                            {data.icon}
                            <span>{data.title}</span>
                        </NavLink>
                    ))}
                </nav>
            )}
        </div>
    )
}

export default Header
